import React from 'react'

export default function Register() {
    return (
        <div className="signup-section ptb-150">
            <div className="container">
                <div className="signup-form">
                    <h3>Create your Account</h3>
                    <form>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder="Username"/>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="form-group">
                                    <input type="email" className="form-control" placeholder="Email"/>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="form-group">
                                    <input type="password" className="form-control" placeholder="Password"/>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" id="checkme"/>
                                    <label className="form-check-label" for="checkme">Keep Me Signup</label>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="send-btn">
                                    <a href="#" className="default-btn">
                                        Signup Now
                                        <span></span>
                                    </a>
                                </div>
                                <br/>
                                <span>Already a registered user? <a href="log-in.html">Login!</a></span>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
